import { useState, useContext, useEffect } from "react";
import { FaLock } from "react-icons/fa";
import { FaUserAlt } from "react-icons/fa";
import { AuthContext } from "../../context/auth-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import { loginService } from "../../services/api-service";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/img/Clogo.png";
import camsecNameTagLine from "../../assets/img/ClogoN.png";
import edu from "../../assets/images/edu.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function App() {
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down("md"));
  const sm_matches = useMediaQuery(theme.breakpoints.down("sm"));
  const { setIsLoggedIn } = useContext(AuthContext);
  const [username, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const history = useHistory();

  useEffect(function () {
    localStorage.clear();
  }, []);

  const handleClick = () => {
    if (username === "" || password === "") {
      toast.warn("Please enter username and password !!!");
    } else {
      var body = {
        username: username,
        password: password,
      };

      const searchParams = new URLSearchParams();
      Object.keys(body).forEach((key) => searchParams.append(key, body[key]));

      loginService(searchParams)
        .then((response) => {
          console.log("🔵 Login response:", response?.data);

          // ✅ Extract the access token - this is the JWT
          const accessToken = response?.data?.access_token;
          
          console.log("🟢 Access token:", accessToken?.substring(0, 50) + "...");
          console.log("🟢 Token length:", accessToken?.length);

          // ✅ Store user data separately from token
          if (accessToken) {
            // Store ONLY the token
            localStorage.setItem("accessToken", accessToken);
            console.log("✅ Token stored in accessToken");

            // Store user data in separate keys or as JSON
            localStorage.setItem("username", response?.data?.username || "");
            localStorage.setItem("image", response?.data?.image || "");
            localStorage.setItem("isOwner", (response?.data?.is_owner ?? false).toString());
            localStorage.setItem("isAdmin", (response?.data?.is_admin ?? false).toString());
            
            // ✅ Optional: Store user data as JSON for easier access
            const userData = {
              username: response?.data?.username,
              image: response?.data?.image,
              is_owner: response?.data?.is_owner,
              is_admin: response?.data?.is_admin,
              role_type: response?.data?.role_type,
              location: response?.data?.location,
              hostel_name: response?.data?.hostel_name,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            console.log("✅ User data stored:", userData);

            // Verify storage
            const storedToken = localStorage.getItem("accessToken");
            console.log("🔍 Verification - Token in storage:", storedToken?.substring(0, 50) + "...");
          }

          if (response?.status === 203) {
            toast.error("Error: Please verify your email !!!");
          }
          if (response?.status === 200) {
            toast.success("Login successful");
            setIsLoggedIn(true);
            history.push("admin/dashboard");
          }
        })
        .catch((error) => {
          // Default error message
          let message = error?.message || "Something went wrong";

          if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
              message = "Session expired, please login again";
              localStorage.clear();
              history.push("/app");
            } else if (status === 403) {
              message = data?.detail || "Error: Invalid email or password";
            } else if (status === 500) {
              message = "Server error, please try again later";
            }
          }

          toast.error(message);
        });
    }
  };

  const togglePassword = () => {
    setIsVisible(!isVisible);
    document.getElementById("pass").type = isVisible ? "password" : "text";
  };

  return (
    <div className="lpage">
      {md_matches ? (
        <div></div>
      ) : (
        <div className="col-6 logoDiv">
          <img
            className="logInLogo"
            src={logo}
            alt="logo"
            style={{ marginLeft: "0px", borderRadius: "10px" }}
          ></img>

          <img
            className="casmecTagLine"
            src={camsecNameTagLine}
            alt="casmecTagLine"
            style={{
              borderRadius: "10px",
              marginLeft: "20px",
            }}
          ></img>

          <div
            style={{
              fontSize: "25px",
              color: "#fff",

              fontWeight: "bold",
              marginTop: "1%",
              borderColor: "black",
            }}
          >
            PROMINI
          </div>
        </div>
      )}
      <div className="details">
        {md_matches ? (
          <>
            <div
              style={{
                fontSize: "25px",
                color: "#fff",
                fontWeight: "bold",
                marginTop: "1%",
                borderColor: "black",
              }}
            >
              UNIVERSAL
            </div>
            <div
              style={{
                fontSize: "25px",
                color: "#fff",
                fontWeight: "bold",
                marginTop: "1%",
                borderColor: "black",
              }}
            >
              SECTOR
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="form-item"
          style={{ width: md_matches ? "200px" : "240px", height: "40px" }}
        >
          <span
            className="material-icons-outlined"
            style={{
              color: "white",
              width: "0px",
              borderRadius: "99px",
              marginLeft: "8px",
              marginRight: "22px",
              lineHeight: "10px",
            }}
          >
            <FaUserAlt />
          </span>
          <input
            type="text"
            name="user"
            id="user"
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="false"
          />
        </div>
        <div
          className="form-item"
          style={{
            marginTop: "14px",
            height: "40px",
            width: md_matches ? "200px" : "240px",
          }}
        >
          <span
            style={{
              color: "white",
              width: "0px",
              borderRadius: "99px",
              marginLeft: "8px",
              marginRight: "22px",
              lineHeight: "10px",
            }}
            className="material-icons-outlined"
          >
            <FaLock />
          </span>
          <input
            type="password"
            name="pass"
            onChange={(e) => setPassword(e.target.value)}
            id="pass"
            autoComplete="off"
          />
          <span
            style={{
              color: "white",
              cursor: "pointer",
              lineHeight: "20px",
            }}
            onClick={togglePassword}
          >
            {isVisible ? (
              <VisibilityIcon fontSize="small" />
            ) : (
              <VisibilityOffIcon fontSize="small" />
            )}
          </span>
        </div>
        <button
          style={{
            width: md_matches ? "200px" : "240px",
            backgroundColor: "white",
            color: "black",
            borderColor: "white",
            marginTop: "5%",
          }}
          onClick={handleClick}
        >
          LOGIN
        </button>
        <b
          style={{
            fontSize: "12px",
            width: md_matches ? "200px" : "100%",
          }}
        >
          <u style={{ color: "white", float: "right", cursor: "pointer" }}>
            Forgot Password
          </u>
        </b>
      </div>
    </div>
  );
}